import React, { useEffect, useState } from "react";
import {
  ClickAwayListener,
  Grid,
  Paper,
  Popper,
  TextField,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import "./gridControls.scss";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

const ValueDetail = ({
  valueName,
  description,
  onUpdate,
  model,
  dd,
  tab,
  ddValueId,
  item,
  sort,
  intl = null,
  fullLangCode = "",
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [name, setName] = useState(injectIntlTranslation(intl, valueName, valueName));
  const [desc, setDesc] = useState(injectIntlTranslation(intl, description, description));
  const [descError, setDescError] = useState("");
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    setName(injectIntlTranslation(intl, valueName, valueName));
    setDesc(injectIntlTranslation(intl, description, description));
  }, [fullLangCode]);

  const open = Boolean(anchorEl);
  const popId = open ? "simple-popper" : undefined;
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickAway = (event) => {
    setAnchorEl(null);
    if (tab === "DD-Values") {
      onUpdate(model, dd, name, desc, ddValueId, sort);
    }
    setName(name);
    setDesc(desc);
    item.description = desc;
  };

  const handleNameUpdate = async (event) => {
    if (event.key === "Enter" && name.trim() !== "" && !nameError) {
      if (tab === "DD-Values") {
        onUpdate(model, dd, name, desc, ddValueId, sort);
      }
      item.name = name;
      item.description = desc;
      setAnchorEl(null);
    }
  };

  const handleDescUpdate = async (event) => {
    if (event.key === "Enter" && desc.trim() !== "" && !descError) {
      if (tab === "DD-Values") {
        onUpdate(model, dd, name, desc, ddValueId, sort);
      }
      item.description = desc;
      item.name = name;
      setAnchorEl(null);
    }
  };

  const onChangeName = (e) => {
    const val = e.target.value || "";
    if (/,/.test(val)) {
      setNameError("comma(,) not allowed");
    } else {
      setNameError("");
    }
    setName(e.target.value);
  };

  const onChangeDesc = (e) => {
    const val = e.target.value || "";
    if (/,/.test(val)) {
      setDescError("comma(,) not allowed");
    } else {
      setDescError("");
    }
    setDesc(e.target.value);
  };

  return (
    <>
      <MoreHorizIcon
        style={{ margin: "0 8px" }}
        className="grid-action-item-multi"
        onClick={handleClick}
      />
      <Popper id={popId} open={open} anchorEl={anchorEl} placement="bottom-end">
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper>
            <div
              style={{
                height: descError || nameError ? "125px" : "106px",
                width: "264px",
                padding: "8px",
                border: "1px none #fffff",
                borderRadius: "4px",
                backgroundColor: "#ffffff",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    label="Value name"
                    value={name}
                    onChange={onChangeName}
                    onKeyDown={handleNameUpdate}
                    style={{
                      fontWeight: 700,
                      color: "#152C73;",
                      padding: "4px",
                    }}
                  />
                  {nameError && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {nameError}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Description"
                    value={desc}
                    onChange={onChangeDesc}
                    onKeyDown={handleDescUpdate}
                    style={{ padding: "4px" }}
                  />
                  {descError && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {descError}
                    </div>
                  )}
                </Grid>
              </Grid>
            </div>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default injectIntl(ValueDetail);
